export default __webpack_public_path__ + "static/media/surrounding3.40fc5790.webp";